import { gql } from '@apollo/client';
import ORGANIZATION_LICENSE_FIELDS from 'graph/fragments/organization-license-fields';

const MASTERCODE_FRAGMENT = gql`
  fragment LicenseDataMastercodeFragment on Mastercode {
    id
    code
    status
    orderItems {
      id
      licenseType
      licenseCount
      dateExpiration
      order {
        orderNumber
        itemFulfillmentNumber
        ecmsOrderNumber
      }
      product {
        id
        code
        name
      }
    }
  }
`;

const GET_LICENSE_DATA = gql`
  query getLicenseData {
    mastercodes(where: { expired: false }) {
      id
      status
      orderItems {
        id
        licenseType
        product {
          id
          code
        }
      }
    }
    organizations(orderBy: { field: NAME, direction: ASC }) {
      id
      name
      parentOrganizationId
      ...OrganizationLicenseFields
      ancestorMastercodes(where: { status: UNLOCKED, orderItems: { trial: false } }) {
        ...LicenseDataMastercodeFragment
      }
      mastercodes(where: { status: UNLOCKED, orderItems: { trial: false } }) {
        ...LicenseDataMastercodeFragment
      }
      rootOrganization {
        id
        ...OrganizationLicenseFields
      }
    }
  }
  ${ORGANIZATION_LICENSE_FIELDS}
  ${MASTERCODE_FRAGMENT}
`;

export default GET_LICENSE_DATA;
